import { render, staticRenderFns } from "./LeftNavbar.vue?vue&type=template&id=39fd4507&scoped=true&"
import script from "./LeftNavbar.vue?vue&type=script&lang=js&"
export * from "./LeftNavbar.vue?vue&type=script&lang=js&"
import style0 from "./LeftNavbar.vue?vue&type=style&index=0&id=39fd4507&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fd4507",
  null
  
)

/* custom blocks */
import block0 from "./LeftNavbar.vue?vue&type=custom&index=0&blockType=i18nf"
if (typeof block0 === 'function') block0(component)

export default component.exports